export default {
    labels: {
        headerTitle: 'Detalle de cargo',
        chargesTitle: 'Soportes de cargo',
        pendingSupportFiles: 'Soporte de cargos faltantes',
        receivedSupportFiles: 'Soporte de cargos adjuntos',
        observations: 'Observaciones'
      },
}